import type { EstadoAuth } from '../api/authApi';

type Props = {
  estado: EstadoAuth | null;
};

/**
 * Faixa horizontal exibida no topo da janela quando o app perde contato
 * com o servidor. Comunica explicitamente o que pára de funcionar
 * (backup, consulta de placa) e tranquiliza sobre o que continua (todos
 * os dados operacionais ficam no SQLite local).
 *
 * Some sozinha quando o status volta para 'online'.
 */
export function BannerOffline({ estado }: Props) {
  if (!estado) return null;
  if (estado.status === 'online') return null;
  // Só mostra para usuários logados — quando deslogado o LoginPage cobre
  // todo o viewport e o banner ficaria escondido por trás.
  if (!estado.logado) return null;

  const cores =
    estado.status === 'offline-bloqueado' || estado.status === 'sem-servidor'
      ? { fundo: '#fee2e2', borda: '#fecaca', texto: '#991b1b' }
      : estado.status === 'offline-leitura'
        ? { fundo: '#fed7aa', borda: '#fdba74', texto: '#9a3412' }
        : { fundo: '#fef3c7', borda: '#fde68a', texto: '#92400e' };

  const titulo =
    estado.status === 'sem-servidor'
      ? 'Sem conexão com o servidor.'
      : estado.status === 'offline-bloqueado'
        ? 'Sem acesso — conecte à internet para revalidar a assinatura.'
        : estado.status === 'offline-leitura'
          ? 'Modo só leitura — offline há mais de 30 dias.'
          : 'Você está offline.';

  // No app web os dados moram no servidor: não existe "continua salvo
  // localmente" para oferecer. O aviso diz o que realmente acontece.
  const detalhe =
    estado.status === 'sem-servidor'
      ? 'O que você digitar agora não será salvo. Reconectando automaticamente — evite fechar a aba.'
      : estado.status === 'offline-bloqueado'
        ? null
        : 'Backup pausado até reconectar. Consulta de placa indisponível. Os demais dados continuam salvos localmente.';

  return (
    <div
      role="status"
      style={{
        background: cores.fundo,
        borderBottom: `1px solid ${cores.borda}`,
        color: cores.texto,
        padding: '8px 16px',
        fontSize: 13,
        textAlign: 'center',
      }}
    >
      <strong>{titulo}</strong>
      {detalhe && <span style={{ marginLeft: 8 }}>{detalhe}</span>}
    </div>
  );
}
